import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

    state: {

        isLoading: false,

        config: {

            eventType: {},

            persons: {
                id: null,
                min: 0,
                max: 10,
                title: "",
                count: null
            },

            seatType: {},

            duration: {
                date_from: null,
                date_to: null,
                time_from: null,
                time_to: null
            },

            inventories: [],

            services: [],

            additionalInfo: {

                overNightStayOffer: {
                    id: null,
                    title: "Möchten Sie ein separates Angebot für eine Übernachtung im Haus erhalten? *",
                    type: "textarea",
                    value: false
                },

                otherWishes: {
                    id: null,
                    title: "Ihre Nachricht",
                    type: "textarea",
                    value: ""
                },

                address: {}

            },

            tos: false,

            privacyPolicy: false,

            resource: {
                id: null,
                title: ""
            }

        },
        
        accountId: null,
        
        settings: {
            hide_price : false
        }

    },

    mutations: {

        UPDATE_TOS(context, payload) {
            context.config.tos = payload
        },

        UPDATE_CONFIG(context, payload) {
            context.config = payload;
        },

        UPDATE_SERVICES(context, payload) {
            context.config.services = payload
        },

        UPDATE_DURATION(context, payload) {
            context.config.duration = payload
        },

        UPDATE_IS_LOADING(context, payload) {
            context.isLoading = payload
        },

        UPDATE_RESOURCE(context, payload) {
            context.config.resource = payload
        },

        UPDATE_INVENTORIES(context, payload) {
            context.config.inventories = payload
        },

        UPDATE_PERSONS(context, payload) {
            context.config.persons = payload
        },

        UPDATE_PRIVACY_POLICY(context, payload) {
            context.config.privacyPolicy = payload
        },

        UPDATE_SEAT_TYPE_CONFIG(context, payload) {
            context.config.seatType = payload;
        },

        UPDATE_EVENT_TYPE_CONFIG(context, payload) {
            context.config.eventType = payload;
        },

        UPDATE_ADDRESS(context, payload) {
            context.config.additionalInfo.address = payload
        },

        UPDATE_OTHER_WISHES(context, payload) {
            context.config.additionalInfo.otherWishes = payload
        },

        UPDATE_OVERNIGHT_STAY_OFFER(context, payload) {
            context.config.additionalInfo.overNightStayOffer = payload
        },
        
        UPDATE_ACCOUNT_ID(context, payload) {
            context.accountId = payload
        },
        
        UPDATE_SETTINGS(context, payload){
            context.settings = payload;
        },
        
        UPDATE_HIDE_PRICE(context, payload){
            context.settings.hide_price = payload;
        }

    },

    actions: {

        updateTos(context, payload) {
            context.commit("UPDATE_TOS", payload)
        },

        updateConfig(context, payload) {
            context.commit('UPDATE_CONFIG', payload)
        },

        updateAddress(context, payload) {
            context.commit("UPDATE_ADDRESS", payload)
        },

        updateDuration(context, payload) {
            context.commit("UPDATE_DURATION", payload)
        },

        updateResource(context, payload) {
            context.commit("UPDATE_RESOURCE", payload)
        },

        updateServices(context, payload) {
            context.commit("UPDATE_SERVICES", payload)
        },

        updateIsLoading(context, payload) {
            context.commit("UPDATE_IS_LOADING", payload)
        },

        updateInventories(context, payload) {
            context.commit("UPDATE_INVENTORIES", payload)
        },

        updateOtherWishes(context, payload) {
            context.commit("UPDATE_OTHER_WISHES", payload)
        },

        updatePersons(context, payload) {
            context.commit('UPDATE_PERSONS', payload)
        },

        updatePrivacyPolicy(context, payload) {
            context.commit("UPDATE_PRIVACY_POLICY", payload)
        },

        updateSeatType(context, payload) {
            context.commit('UPDATE_SEAT_TYPE_CONFIG', payload)
        },

        updateEventType(context, payload) {
            context.commit("UPDATE_EVENT_TYPE_CONFIG", payload);
        },

        updateOverNightStayOffer(context, payload) {
            context.commit("UPDATE_OVERNIGHT_STAY_OFFER", payload)
        },
        
        updateAccountId(context, payload) {
            context.commit("UPDATE_ACCOUNT_ID", payload)
        },
        
        updateSettings(context, payload) {
            context.commit("UPDATE_SETTINGS", payload)
        },
        
        updateHidePrice(context, payload) {
            context.commit("UPDATE_HIDE_PRICE", payload)
        },

        async saveConfiguratorToServer(context) {

            let params = context.getters.getConfigurator;

            params.services = context.getters.getServices.filter(service => service.count)
            params.inventories = context.getters.getInventories.filter(inventory => inventory.count)

            context.commit("UPDATE_IS_LOADING", true);

            const response = await Vue.prototype.$http.saveConfigurator(params);

            context.commit("UPDATE_IS_LOADING", false);

            // go to success page after save
            if (response.success) {
                Vue.prototype.$configuratorRouter.push({name: 'Finish'})
            }

            return response.success ? null : response.data.message

        }
    },

    getters: {

        getTos: context => context.config.tos,

        getIsLoading: context => context.isLoading,

        getConfigurator: context => context.config,

        getResource: context => context.config.resource,

        getServices: context => context.config.services,

        getSeatType: context => context.config.seatType,

        getDuration: context => context.config.duration,

        getEventType: context => context.config.eventType,

        getInventories: context => context.config.inventories,

        getPersons: context => context.config.persons,

        getPrivacyPolicy: context => context.config.privacyPolicy,

        getAddress: context => context.config.additionalInfo.address,

        getOtherWishes: context => context.config.additionalInfo.otherWishes,

        getOverNightStayOffer: context => context.config.additionalInfo.overNightStayOffer,
        
        getAccountId: context => context.accountId,
        
        getSettings: context => context.settings,
        
        getHidePrice: context => context.settings.hide_price

    },

    modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js